<div [hidden]="collapsed">
  @if (loaded) {
    <ng-content></ng-content>
  }
</div>
